export default "__VITE_ASSET__ae650773__"